import { render, staticRenderFns } from "./AamsDocumentRegCancelInfo.vue?vue&type=template&id=5ab30294&scoped=true&"
import script from "./AamsDocumentRegCancelInfo.vue?vue&type=script&lang=js&"
export * from "./AamsDocumentRegCancelInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab30294",
  null
  
)

export default component.exports